import React from "react";
import styles from "./scss/Input.module.scss"

const Input = ({ label, type, id, name, placeholder }) => {
  return (
    <div className={styles.inputContainer}>
      <label htmlFor={id}>{label}</label>
      <input type={type} id={id} name={name} placeholder={placeholder} />
    </div>
  );
};

export default Input;
